import { createSlice } from "@reduxjs/toolkit";
const cartSlice = createSlice({
    name:'cart',
    initialState:{
     cart:[],
     totalAmount:0,
     amount:0,
     totalPrice:0,
     user_name: null,
     emailId:null,
     credential:null,
    },
    reducers:{
        addtocart(state,action){
            const item = action.payload;
            const exist = state.cart.find((product)=>
                product.id === item.id)
            if (exist) {
                exist.amount++;
                exist.totalPrice += item.price;
                state.totalAmount++;
                state.totalPrice += item.price;
              } else {
                state.cart.push({
                  id: item.id,
                  price: item.price,
                  amount: 1,
                  img: item.images,
                  totalPrice: item.price,
                  title: item.title,
                  description: item.description,
                });
                state.totalAmount++;
                state.totalPrice += item.price;
        }

        },
        removeFromCart(state, action){
            const item = action.payload;
            const exist = state.cart.find((product)=>
                product.id === item.id)
            if(exist.amount > 1){
                exist.amount--;
                exist.totalPrice -= item.price;
                state.totalAmount--;
                state.totalPrice -= item.price;
            }
            else{
            state.cart = state.cart.filter((product)=>{
            return product.id !== item.id
           })
           state.totalAmount --;
           state.totalPrice-= item.price;
            }

        },
       login(state,action){
        const item = action.payload;
   // state.user_name = item.user_name;
    //state.emailId = item.emailId;
    state.credential = item.credential;
       },
       logout(state){
     state.credential = null;
       }
}
})
export const {addtocart , removeFromCart,login,logout} = cartSlice.actions;
export default cartSlice.reducer;